import React, { useState } from 'react';
import { Volume2, X } from 'lucide-react';
import { alertBanner } from '../mockData';
import { Button } from './ui/button';

const AlertBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="bg-gray-50 border-b border-gray-200">
      <div className="max-w-[1400px] mx-auto px-6 py-6">
        <div className="flex items-start justify-between gap-4">
          <div className="flex items-start gap-4 flex-1">
            <Volume2 className="w-6 h-6 text-[#0A1F3B] flex-shrink-0 mt-1" />
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-[#0A1F3B] mb-2">
                {alertBanner.title}
              </h3>
              <p className="text-sm text-gray-600 mb-4">
                {alertBanner.description}
              </p>
              <Button 
                variant="default" 
                className="bg-[#0A1F3B] hover:bg-[#0A1F3B]/90 text-white"
              >
                {alertBanner.link}
              </Button>
            </div>
          </div>
          <button
            onClick={() => setIsVisible(false)}
            className="text-gray-400 hover:text-gray-600 transition-colors p-1"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertBanner;